import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "./i18n";
import { CATEGORIES } from "./data/materials";
import { track } from "./analytics";
import "./WeTakeStrip.css";

/**
 * WE TAKE EVERYTHING — the cinematic "what we recover" band on the homepage.
 * One tile per material category (renders in public/materials/, data in
 * src/data/materials.ts). Each tile opens the searchable directory on the
 * pickup page with that category preselected.
 */

const COPY = {
  en: {
    kicker: "What we recover",
    h1: "We take",
    h2: "everything.",
    sub: "Electronics, textiles, tools, copper, toys — if it still has a life in it, we'll find it. Reuse first, repair second, recycle last.",
    cta: "See the full list",
    tile: "See what counts →",
  },
  es: {
    kicker: "Lo que recuperamos",
    h1: "Nos llevamos",
    h2: "todo.",
    sub: "Electrónicos, textiles, herramientas, cobre, juguetes — si todavía le queda vida, la encontramos. Reúso primero, reparación segundo, reciclaje al final.",
    cta: "Ver la lista completa",
    tile: "Ver qué cuenta →",
  },
};

const WeTakeStrip: React.FC = () => {
  const { lang } = useLang();
  const L = COPY[lang];
  return (
    <section id="wetake" className="wt-section">
      <div className="ee-container">
        <div className="wt-head">
          <div className="wt-kicker">{L.kicker}</div>
          <h2 className="wt-title">
            {L.h1} <em>{L.h2}</em>
          </h2>
          <p className="wt-sub">{L.sub}</p>
        </div>

        <div className="wt-row" role="list">
          {CATEGORIES.map((c) => (
            <Link
              key={c.id}
              role="listitem"
              to={`/pickup?cat=${c.id}#accept`}
              className="wt-tile"
              onClick={() => track("item_category_selected", { category: c.id, source: "wetake_strip" })}
            >
              <img src={c.image} alt="" decoding="async" />
              <div className="wt-shade" />
              <div className="wt-body">
                <span className="wt-icon" aria-hidden="true">{c.icon}</span>
                <strong>{c.title[lang]}</strong>
                <p>{c.tagline[lang]}</p>
                <span className="wt-go">{L.tile}</span>
              </div>
            </Link>
          ))}
        </div>

        <div className="wt-cta">
          <Link to="/pickup#accept" className="ee-btn ee-btn-green" onClick={() => track("pickup_cta_clicked", { source: "wetake_strip" })}>
            {L.cta}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default WeTakeStrip;
